export const environment = {
  base_url: 'https://dev.service.liveness.verifiedge.com',
  allowed_origin: 'https://dev.app.liveness.verifiedge.com',
  dataLimit: '5',
  production: false,
};
